import {BaseApplet} from "../BaseApplet";
import React from "react";
import {StyledEmpty} from "../../../shared/StyledComponents";
import {ContentPasteOutlined} from "@mui/icons-material";

export class OrdersApplet extends BaseApplet {
  protected renderApplet(): React.ReactElement {
    return <StyledEmpty emptyConfig={{
      title: "No orders yet",
      text: "When you place orders, they will show up here.",
      iconType: ContentPasteOutlined,
    }}/>;
  }
}